import { render, staticRenderFns } from "./add-round-modal.vue?vue&type=template&id=3c32ada2"
import script from "./add-round-modal.vue?vue&type=script&lang=js"
export * from "./add-round-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports